import { render, staticRenderFns } from "./WealthView.vue?vue&type=template&id=180291ae&scoped=true&"
import script from "./WealthView.vue?vue&type=script&lang=ts&"
export * from "./WealthView.vue?vue&type=script&lang=ts&"
import style0 from "./WealthView.vue?vue&type=style&index=0&id=180291ae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180291ae",
  null
  
)

export default component.exports